import { disableBodyOverflow } from '../../utils/disableBodyOverflow.js';
import { updateBrowserControlState } from '../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import { EVENTS } from '../../constants/events.js';
import App from './App.svelte.js';

function appPurchaseProduct (isClosable, events) {
    events.emit(EVENTS.OVERLAY_VISIBILITY, { visible: true });
    const app = new App({
        target: document.body,
        props: {
            isClosable,
            closeApplication,
        },
    });
    function closeApplication() {
        events.emit(EVENTS.OVERLAY_VISIBILITY, { visible: false });
        disableBodyOverflow(false);
        updateBrowserControlState(false);
        app.$destroy();
    }
    events.subscribe(EVENTS.CLOSE_FASTGOLD_OVERLAY, closeApplication);
    updateBrowserControlState(isClosable);
}

export { appPurchaseProduct as default };
//# sourceMappingURL=index.js.map
